import React, {useState, useEffect, useRef, useCallback }        from "react";
import {useLoader}                          from "components/Covers/loadingCover";
import {useActionModal}                     from "components/Covers/confirmAction";
import {useInfoMsgModal}                    from "components/Covers/infoMessageModal";
import {useToastMessage}                    from "components/Covers/toastMessage";
import {InputGeneral}                       from "components/Field/field";
import {BtnCloseAction}                     from "components/Buttons/Close/BtnClose";
import MainStyle                            from "components/UI/main.module.scss";
import { 
    getPatternList,
    getQuestionList,
    getPatternByID,
    updatePattern,
    deletePattern,
    getPatternUsers,
    insertPatternUser,
    removePatternUser
}                                           from "./patternService";
// BEGIN AG AGRID
import {AgGridReact}                        from "ag-grid-react";
import {AllCommunityModule,ModuleRegistry}  from 'ag-grid-community';
import {AG_GRID_LOCALE_BR}                  from '@ag-grid-community/locale';
import { q3x_FunData, 
         getImgSrc,
         DefaultLoadingLogo,
         DavidCopperfield,
         Heimdall,
         GetLabel,
         GetAppLang,
         SetLastFeature}                    from "Utilities/utils"
import { Select }                           from "antd";
import { useNavigate }                      from "react-router-dom";

/*  Drag and drops libs  */
import { DndProvider, useDrag, useDrop }    from 'react-dnd';
import { HTML5Backend }                     from 'react-dnd-html5-backend';
import { TouchBackend }                     from 'react-dnd-touch-backend';
import {DisplayGridDatetime}                from "components/Date/date";

const getDndBackend = () => {
    const isTouchDevice =
      typeof window !== 'undefined' &&
      ('ontouchstart' in window || navigator.maxTouchPoints > 0);
  
    return {
      backend: isTouchDevice ? TouchBackend : HTML5Backend,
      options: isTouchDevice ? { enableMouseEvents: true } : undefined,
    };
};

let blank_pattern_obj = {
    PATTERN_ID:         0,
    PATTERN_DESC:       "",
    STATUS_ID:          1,
    QUESTIONS:          []
};
let blank_pattern_question_obj = {
    QUESTION_ID:        0,
    QUESTION_POSITION:  0,
    MANDATORY:          "",
    BOLD:               "",
    PREFIX:             ""
};
let blank_pattern_users_obj = {
    PATTERN_ID:         0,
    PATTERN_USERS_LIST: [],
    USERS_LIST:         []
};
let blank_user_obj = {
    USER_ID: 0,
    FULL_NAME: "",
    COMPANY_POSITION_DESC: "",
    SECTOR_DESC: "",
    FILE_DATA: ""
};
let appLang = null;
/*
const DropdownList = ({
    className,
    style,
    onChange,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value}) => {
  return (
    <Select
      name={name}
      id={id}
      placeholder={placeholder}
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      options={listOfItems}
      className={className}
      style={style}
      onChange={onChange}
      defaultValue={defaultValue}
      title={title}
      popupClassName={popupClassName}
      value={value}
    />
  );
};
*/
const DropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
  }) => {
    return (
      <Select
        showSearch
        allowClear
        id={id}
        name={name}
        value={value} // use directly from props
        placeholder={placeholder}
        className={className}
        style={style}
        title={title}
        popupClassName={popupClassName}
        options={listOfItems}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={(val, option) => {
          onChange?.(val, option); // lift change to parent
        }}
        onSearch={(val) => {
          onSearch?.(val);
        }}
        notFoundContent={null}
      />
    );
};

const DivisionBlock = () => {
    return(
        <>
            <div className={[MainStyle.py_2].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_1}/>
                    <div className={[MainStyle.col_lg_10, MainStyle.border_bottom].join(" ")}/>
                    <div className={MainStyle.col_lg_1}/>
                </div>
            </div>
        </>
    );
};

const DefaultPadding = () =>{
    return(
        <>
            <div className={MainStyle.py_3}/>
        </>
    );
}

const Avatar = () => {
    return (
        <svg viewBox="0 -5 66 66" xmlns="http://www.w3.org/2000/svg" style={{ backgroundColor: '#f0f0f0', width: '100%', height: '100%'}}>
            <circle className={MainStyle.avatar_head} cx="32" cy="22" r="12" fill="#707070"/>
            <path d="M32 36c-9 0-20 6-20 14v14h40V50c0-8-11-14-20-14z" fill="#707070"/>
            <ellipse className={MainStyle.avatar_eye_left} cx="27" cy="20" rx="2" ry="2" fill="#fff"/>
            <ellipse className={MainStyle.avatar_eye_right} cx="37" cy="20" rx="2" ry="2" fill="#fff"/>
        </svg>
    );
};

const QuestionItem =  React.memo(({ mainProp, prop, setProp, index, moveItem, onDelete, questionList }) => {
    const { showInfoMessage   } = useInfoMsgModal(); // Modal message control 
    const { showActionMessage } = useActionModal();  // Modal message + action control     
    const { showToastMessage  } = useToastMessage(); // Toast message display
    const itemRef               = useRef(null);

    const handleInputChange      = (field, value) => {
        setProp(index, { [field]: value });
    };
    
    const handleEdit             = () => {
        if (!prop.IsEditing) {
            handleInputChange("IsEditing", true);
        }
        else {
            handleInputChange("IsEditing", false);
        }
    };

    const handleDelete = () => {
        if(mainProp.QUESTIONS.length === 1) {
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 169)});            
            return;
        }
        if (prop.QUESTIONS == 0) {
            onDelete(prop.QUESTION_ID, index);
        }
        else {
            showActionMessage(
                { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 58)}<br/>{GetLabel(appLang, 59)}</> },
                { confirm_action: () => onDelete(prop.QUESTION_ID, index)}
            );
            return;
        }
    };


    const LabelAvaliableLang = ({question_id}) => {
        if (question_id > 0){
            let obj = questionList.find((i) => i.QUESTION_ID === Number(question_id));
            let labels = [];
            if (obj.LANG_PT === "Y") {
                labels.push(GetLabel(appLang, 204));
            }
            if (obj.LANG_EN === "Y") {
                labels.push(GetLabel(appLang, 205));
            }
            if (obj.LANG_ES === "Y") {
                labels.push(GetLabel(appLang, 206));
            }
            return (labels.join(", "));
        }
        return(null);
    };

    const AvailableIcon = ({param}) => {
        return (        
            <>
                <div 
                    className={[ MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    {
                        param == "Y" ?
                            <svg 
                                xmlns="http://www.w3.org/2000/svg" 
                                viewBox="0 0 448 512"
                                className={[MainStyle.ico_checked].join(" ")}
                            >
                                <defs>
                                    <linearGradient id="checkmarkGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                        <stop offset="0%"    stopColor="rgba(48, 255, 158)" />
                                        <stop offset="80%"   stopColor="rgba(16, 90, 56)" />
                                    </linearGradient>
                                </defs>
                                <path 
                                    d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
                                    fill="url(#checkmarkGradient)"
                                />
                            </svg>
                        :
                            <svg 
                                xmlns="http://www.w3.org/2000/svg" 
                                viewBox="0 0 384 512"
                                className={[MainStyle.ico_checked].join(" ")}
                            >
                                <defs>
                                    <linearGradient id="xmarkGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                        <stop offset="0%"    stopColor="rgba(220, 53, 69)" />
                                        <stop offset="80%"   stopColor="rgba(160, 39, 51)" />
                                    </linearGradient>
                                </defs>
                                <path 
                                    d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                                    fill="url(#xmarkGradient)"
                                />
                            </svg>
                    }
                </div>
            </>
        );
    };

    const [{ handlerId }, drop]  = useDrop(
        {
        accept: 'card',        
        collect(monitor) {
          return {
            handlerId: monitor.getHandlerId(),
          }
        },
        hover(item, monitor) {
            if (!itemRef.current) {
              return;
            }
          
            const dragIndex = item.index;
            const hoverIndex = index;
          
            // Do nothing if dragging over itself
            if (dragIndex === hoverIndex) {
              return;
            }
          
            // Get bounding rectangle
            const hoverBoundingRect = itemRef.current.getBoundingClientRect();        
          
            // Get vertical middle
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
          
            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
          
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
          
            // Only perform the move when the mouse has crossed half of the item's height
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
              return;
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
              return;
            }
          
            // Time to actually perform the action
            moveItem(dragIndex, hoverIndex);
          
            // Note: mutate the monitor item to update the index
            item.index = hoverIndex;
          }
    });
    
    const [{ isDragging }, drag] = useDrag({
        type: 'card',
        item: () => {
          const id = prop.OPTION_LIST_ITEM_ORDER;
          return { id, index };
        },
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
        }),
    });
    const opacity                = isDragging ? 0.4 : 1;

    drag(drop(itemRef));

    return (
        <>
            <div data-handler-id    =   {handlerId}
                 ref                =   {itemRef}
                 style              =   {{ opacity, cursor: 'grab' }}
                 className          =   {[MainStyle.row, MainStyle.mx_3, MainStyle.py_1, MainStyle.bg_card_item, MainStyle.shadow_sm, MainStyle.border, MainStyle.rounded].join(" ")}>
                    {/*         Item Position                */}
                    <div className={[MainStyle.col_lg_1, MainStyle.align_items_center, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <span className={[  
                                            MainStyle.fs_7,
                                            MainStyle.text_body,
                                            MainStyle.fw_semibold,
                                            MainStyle.mt_1].join(" ")}>
                            { index  + 1 }
                        </span>                                
                    </div> 

                    {/*         Question Selection         */}
                    <div className={[MainStyle.col_lg].join(" ")}>
                        <div className={MainStyle.m_2}>
                            <span className={[  MainStyle.fs_6,
                                                MainStyle.text_body,
                                                MainStyle.fw_semibold].join(" ")}>
                                {GetLabel(appLang, 207)}
                            </span>
                            {
                                prop.IsEditing ?
                                    <>
                                        <DropdownList
                                            value={prop.QUESTION_ID > 0 ? parseInt(prop.QUESTION_ID) : undefined}
                                            placeholder={GetLabel(appLang, 208)}
                                            listOfItems={questionList.map((i) => ({value: i.QUESTION_ID, label: i.QUESTION_DESC}))}
                                            style={{ width: "100%" }}
                                            className={MainStyle.antd_custom_select}
                                            popupClassName={MainStyle.antd_custom_select}
                                            onChange={(event) => handleInputChange("QUESTION_ID", event)}
                                        />
                                        <span className={[MainStyle.ms_2, 
                                                          MainStyle.text_wrap,
                                                          MainStyle.text_body_faded, 
                                                          MainStyle.fs_8].join(" ")}
                                        >
                                           {GetLabel(appLang, 209)}: <LabelAvaliableLang question_id={prop.QUESTION_ID}/>
                                        </span>
                                    </>
                                :
                                    <>
                                    <p className={[  MainStyle.fs_7,
                                                     MainStyle.text_wrap, 
                                                     MainStyle.text_body].join(" ")}
                                    >
                                        {questionList?.find((i) => i.QUESTION_ID === Number(prop.QUESTION_ID))?.QUESTION_DESC || GetLabel(appLang, 229)}
                                    </p>
                                    <span className={[MainStyle.text_body_faded, 
                                                      MainStyle.text_wrap,
                                                      MainStyle.fs_8].join(" ")}
                                    >
                                       {GetLabel(appLang, 209)}: <LabelAvaliableLang question_id={prop.QUESTION_ID}/>
                                    </span>
                                    </>
                            }
                        </div>
                    </div>

                    {/*         Prefix Description         */}
                    <div className={[MainStyle.col_lg].join(" ")}>
                        <div className={MainStyle.m_2}>
                            <span className={[  MainStyle.fs_6,
                                                MainStyle.text_body,
                                                MainStyle.fw_semibold,].join(" ")}>
                                {GetLabel(appLang, 210)}
                            </span>
                            {
                                prop.IsEditing ?
                                    <>
                                        <InputGeneral 
                                            value={prop.PREFIX || ''}
                                            className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                            onChange={(event) => handleInputChange("PREFIX", q3x_FunData(event.target.value))}
                                            placeholder={GetLabel(appLang, 176)}
                                            maxLength={50}
                                        />
                                        <span className={[MainStyle.ms_2, 
                                                         MainStyle.text_body_faded, 
                                                         MainStyle.fs_8].join(" ")}
                                        >
                                            {prop.PREFIX.length} {GetLabel(appLang, 44)} 50 {GetLabel(appLang, 45)}.
                                        </span>
                                    </>
                                :
                                    <p className={[  MainStyle.fs_7, 
                                                     MainStyle.text_body].join(" ")}
                                    >
                                        {prop.PREFIX.length > 0 ? prop.PREFIX : GetLabel(appLang, 211)}
                                    </p>
                            }
                        </div>
                    </div>

                    {/*         Mandatory CheckMark        */}
                    <div className={[MainStyle.col_lg, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <div className={MainStyle.m_2}>
                            <div>
                                <span className={[  MainStyle.fs_6,
                                                    MainStyle.text_body,
                                                    MainStyle.fw_semibold,].join(" ")}>
                                    {GetLabel(appLang, 212)}
                                </span>
                            </div>
                            {
                                prop.IsEditing ?
                                    <>
                                        <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_2].join(" ")}>
                                            <input
                                                type="checkbox"
                                                name={"read"}
                                                checked={prop.MANDATORY === "Y" ? true : false}
                                                onChange={()=> {
                                                        prop.MANDATORY === "N"? 
                                                              handleInputChange("MANDATORY", "Y") 
                                                            : handleInputChange("MANDATORY", "N")
                                                        }
                                                }
                                                style={{ transform: "scale(1.5)" }}
                                                disabled={false}
                                            />
                                        </div>
                                    </>
                                :
                                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                        <AvailableIcon param={prop.MANDATORY}/>
                                    </div>
                            }
                        </div>
                    </div>

                    {/*         Bold    Text              */}
                    <div className={[MainStyle.col_lg, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <div className={MainStyle.m_2}>
                            <div>
                                <span className={[  MainStyle.fs_6,
                                                    MainStyle.text_body,
                                                    MainStyle.fw_semibold,].join(" ")}>
                                    {GetLabel(appLang, 213)}
                                </span>
                            </div>
                            {
                                prop.IsEditing ?
                                    <>
                                        <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_2].join(" ")}>
                                            <input
                                                type="checkbox"
                                                name={"read"}
                                                checked={prop.BOLD === "Y" ? true : false}
                                                onChange={()=> {
                                                        prop.BOLD === "N"? 
                                                              handleInputChange("BOLD", "Y") 
                                                            : handleInputChange("BOLD", "N")
                                                        }
                                                }
                                                style={{ transform: "scale(1.5)" }}
                                                disabled={false}
                                            />
                                        </div>
                                    </>
                                :
                                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                        <AvailableIcon param={prop.BOLD}/>
                                    </div>
                            }
                        </div>
                    </div>

                    {/*         Ico Edit                    */}
                    <div className={[MainStyle.col_lg_1, MainStyle.align_items_center, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <div className={MainStyle.m_2}>
                            {
                                prop.IsEditing ? 
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {handleEdit();}}>
                                        <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                        </svg>
                                    </div>
                                :
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {handleEdit();}}>
                                        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                                        </svg>
                                    </div>
                            }
                        </div>
                    </div>
                    {/*         Ico Trash                   */}
                    <div className={[MainStyle.col_lg_1, MainStyle.align_items_center, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <div className={MainStyle.m_2}>
                            <div 
                                onClick={() => {handleDelete()}}
                                className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                    <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    {/*         Ico Arrow Draggable         */}
                    <div className={[MainStyle.col_lg_1, MainStyle.align_items_center, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <div className={MainStyle.m_2}>
                            <div 
                                className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                    <path d="M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3l0 293.5L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7l0-293.5 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"/>
                                </svg>
                            </div>
                        </div>                                            
                    </div>
            </div>
        </>
    );
});

const QuestionList = ({ mainObject, setMainObject, questionList }) => {
    const { backend, options } = getDndBackend();

    const addNewItem    = () => {
        // Create a new object
        const newObject = {
            ...blank_pattern_question_obj, // Copy the template
            QUESTION_ID:        0,
            QUESTION_POSITION:  mainObject.QUESTIONS.length + 1,
            MANDATORY:          "N",
            BOLD:               "N",
            PREFIX:             "",
            IsEditing: true,
        };
    
        // Update state correctly by creating a new array
        setMainObject(prevState => ({
            ...prevState,
            QUESTIONS: [...prevState.QUESTIONS, newObject]
        }));
    };

    const setItem       = useCallback((itemIndex, updatedFields) => {
        setMainObject(prev => {
          const newItems = [...prev.QUESTIONS];
          newItems[itemIndex] = {
            ...newItems[itemIndex],
            ...updatedFields
          };
          return {
            ...prev,
            QUESTIONS: newItems
          };
        });
    }, []);

    const moveItem      = useCallback((dragOrder, hoverOrder) => {
        setMainObject(prevState => {
            const updatedItems = [...prevState.QUESTIONS];
    
            // Directly use dragOrder and hoverOrder as array indices
            const dragIndex = dragOrder;
            const hoverIndex = hoverOrder;
    
            if (dragIndex === -1 || hoverIndex === -1 || dragIndex === hoverIndex) {
                return prevState;
            }
    
            // Remove the dragged item
            const [movedItem] = updatedItems.splice(dragIndex, 1);
    
            // Insert it at the new position
            updatedItems.splice(hoverIndex, 0, movedItem);
    
            // After moving, fix all OPTION_LIST_ITEM_ORDER to match the new array order
            const reorderedItems = updatedItems.map((item, index) => ({
                ...item,
                QUESTION_POSITION: index + 1, // 0-based order now, matching array index
            }));
    
            return {
                ...prevState,
                QUESTIONS: reorderedItems,
            };
        });
    }, []);

    function reorderItems () {
        setMainObject(prevState => {
            const reorderedItems = prevState.QUESTIONS.map((item, index) => ({
                ...item,
                QUESTION_POSITION: index + 1, // 0-based order now, matching array index
            }));
        
            return {
                ...prevState,
                QUESTIONS: reorderedItems,
            };
        });
    }
    
    function handleItemDelete(item_id, item_position) {
        // Delete by position
        setMainObject(prevState => {
            const updatedItems = prevState.QUESTIONS.filter(item => item.QUESTION_POSITION -1 !== item_position);

            const reorderedItems = updatedItems.map((item, idx) => ({
                ...item,
                QUESTION_POSITION: idx,
            }));

            return {
                ...prevState,
                QUESTIONS: reorderedItems,
            };
        });
        reorderItems();
        /*
        if (item_id !== 0) {
            // Delete by ID
            setMainObject(prevState => {
                const updatedItems = prevState.QUESTIONS.filter(item => item.QUESTION_ID !== item_id);
    
                const reorderedItems = updatedItems.map((item, idx) => ({
                    ...item,
                    QUESTION_POSITION: idx,
                }));
    
                return {
                    ...prevState,
                    QUESTIONS: reorderedItems,
                };
            });
            reorderItems();
        } else {
            // Delete by position
            setMainObject(prevState => {
                const updatedItems = prevState.QUESTIONS.filter(item => item.QUESTION_POSITION -1 !== item_position);
    
                const reorderedItems = updatedItems.map((item, idx) => ({
                    ...item,
                    QUESTION_POSITION: idx,
                }));
    
                return {
                    ...prevState,
                    QUESTIONS: reorderedItems,
                };
            });
            reorderItems();
        }
        */
    }

    const renderItem    = useCallback((mainProp, prop, setProp, index, moveItem) => {
        //const itemKey = prop.QUESTION_ID === 0 ? 
        //    `temp-${prop.QUESTION_POSITION}` // Use order as a temporary unique identifier
        //: 
        //    prop.QUESTION_ID;           // Use the stable ID when available
        return (
            <QuestionItem
                //key={itemKey}
                index={index}
                id={index}
                prop={prop}
                setProp={setProp}
                mainProp={mainProp}
                moveItem={moveItem}
                onDelete={handleItemDelete}
                questionList={questionList}
            />
        );
    }, []);

    return (
        <>
            <DndProvider backend={backend} options={options}>
            <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                <div className={MainStyle.col_lg_1}/>
                <div className={MainStyle.col_lg_8}>
                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                        <span className={[MainStyle.fs_6,
                                            MainStyle.text_body,
                                            MainStyle.fw_semibold
                                        ].join(" ")}
                        >
                            {GetLabel(appLang, 180)}:
                        </span>
                    </div>
                </div>
                <div className={MainStyle.col_lg_2}>
                    <div className={MainStyle.mx_3}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_blue, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_7,
                                        MainStyle.text_white,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={addNewItem}
                        >
                            {GetLabel(appLang, 181)}
                        </button>
                    </div>
                </div>
                <div className={MainStyle.col_lg_1}/>
            </div>
            
            {/*         Some spacing         */}
            <div className={MainStyle.py_3}/>
            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_1}/>
                <div className={MainStyle.col_lg_10}>

                    <div className={MainStyle.my_3}>
                        {
                            <div>
                                {   mainObject.QUESTIONS.length > 0 ?
                                        mainObject.QUESTIONS.map((item, i) => renderItem(mainObject, 
                                                                                         item, 
                                                                                         setItem, 
                                                                                         i, 
                                                                                         moveItem))
                                    : 
                                        null
                                }
                            </div>
                        }
                    </div>



                </div>

                <div className={MainStyle.col_lg_1}/>
            </div>
            </DndProvider>
        </>
    );

};

const PatternEditPanel = ({setProps, data, questionList }) => {
    const { showLoader,       hideLoader              }  = useLoader();                  // Control over the loader
    const { showInfoMessage                           }  = useInfoMsgModal();            // Modal message control 
    const { showActionMessage                         }  = useActionModal();             // Modal message + action control     
    const { showToastMessage                          }  = useToastMessage();            // Toast message display
    const [ patternObj,       setPatternObj           ]  = useState(blank_pattern_obj);  // Pattern object

    function validateRecord(obj) {
        let passed = true;
        if (obj.PATTERN_DESC === ""){
            passed = false;
        }
        else if (obj.QUESTIONS.length === 0) {
            passed = false;
        }
        for (let i = 0; i < obj.QUESTIONS.length; i++) {
            if (obj.QUESTIONS[i].QUESTION_ID === 0 || obj.QUESTIONS[i].QUESTION_ID === null || obj.QUESTIONS[i].QUESTION_ID === undefined) {
                passed  = false;
                break;
            }
        }
        return (passed);
    }

    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_pattern_obj });
    };

    const BtnExit = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 102)}<br/>{GetLabel(appLang, 103)}</> },
          { confirm_action: () => handleExit()}
        );
    };        

    const handleSave = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await updatePattern(patternObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
                if (patternObj.PATTERN_ID === 0) {
                    setProps({ setScreen: 1, data: blank_pattern_obj });
                }
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleDelete = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await deletePattern(patternObj.PATTERN_ID);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                setProps({ setScreen: 1, data: blank_pattern_obj });   
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleChange = (updatedValues) => {
        const mergedValues = {
            ...patternObj,
            ...updatedValues
        };
        setPatternObj(mergedValues);
    };

    const BtnSave = () => {
        if (validateRecord(patternObj)) {
            showActionMessage(
                { header: GetLabel(appLang, 54), message: GetLabel(appLang, 214) },
                { confirm_action: () => handleSave()}
            );
            return;
        }
        else {
            showInfoMessage({header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 185)}<br/>{GetLabel(appLang, 186)}<br/>{GetLabel(appLang, 187)}</>});
            return;
        }
    };

    const BtnDelete = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 215) },
          { confirm_action: () => handleDelete()}
        );
    };

    useEffect(() => {
        const fetchData = async (pattern_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getPatternByID(pattern_id);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            setPatternObj(fetchedData || blank_pattern_obj);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }                        
            } 
            catch (error) {
                setPatternObj(blank_pattern_obj);
            }
        };
        if (data?.PATTERN_ID && data.PATTERN_ID !== 0) {
            fetchData(data.PATTERN_ID);
        } 
        else {
            setPatternObj(blank_pattern_obj);
        }
    }, [data]);

    return(
        <>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={BtnExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>

                    <div className={MainStyle.mt_5}/>
                    {/*                 Pattern Description           */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 216)}*:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <InputGeneral 
                                    value={patternObj.PATTERN_DESC}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                    onChange={(event) => handleChange({ PATTERN_DESC: q3x_FunData(event.target.value) })}
                                    placeholder={GetLabel(appLang, 217)}
                                    maxLength={150}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{patternObj.PATTERN_DESC.length} {GetLabel(appLang, 44)} 150 {GetLabel(appLang, 45)}.</span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>                

                    {/*                 Division Block                 */}
                    <DivisionBlock/>

                    <div className={MainStyle.py_3}/>

                    {   /*             Items Label + btn New + items       */}
                    <QuestionList mainObject={patternObj} setMainObject={setPatternObj} questionList={questionList}/>


                    <div className={MainStyle.py_3}/>
                </div>
                
                <div className={MainStyle.my_5}/>

            </div>
            {/*--------------------------------------------------------------------------*/}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_7}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(10,89,6) && (
                        patternObj.PATTERN_ID != 0 ? 
                            <div className={[MainStyle.mt_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={() => {BtnDelete()}}
                                >
                                    {GetLabel(appLang, 114)}
                                </button>
                            </div>
                    : 
                        null
                    )}
                </div>
                <div className={MainStyle.col_lg_1}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(10,89,4) && (
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_green, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_3].join(" ")}
                                onClick={BtnSave}
                            >
                                {GetLabel(appLang, 49)}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {/*--------------------------------------------------------------------------*/}                                    
        </>
    );

};

const SelectDataPopup = ({displayModal, setDisplayModal, objectSet, mainDataset, dataset}) => {
    const { showLoader,  hideLoader     }  = useLoader();         // Control over the loader
    const { showInfoMessage             }  = useInfoMsgModal();   // Modal message control     
    const { showToastMessage            }  = useToastMessage();   // Toast message display
    const [searchString, setSearchString] = useState("");
    const [filteredData, setFilteredData] = useState(dataset);

    const handleSelect = async (user_id, full_name, position_desc, sector_desc, file_data) => {
        if (mainDataset.PATTERN_USERS_LIST.some((u) => u.USER_ID === user_id)) {
            showToastMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 218)});
            //setDisplayModal(false);
            return;
        }

        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await insertPatternUser(mainDataset.PATTERN_ID, user_id);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
                
                //  Handle the object state
                const newObject = {
                    ...blank_user_obj,
                    USER_ID:   user_id,
                    FULL_NAME: full_name,
                    COMPANY_POSITION_DESC: position_desc,
                    SECTOR_DESC: sector_desc,
                    FILE_DATA: file_data,
                };
    
                const newList = [...mainDataset.PATTERN_USERS_LIST, newObject];

                objectSet({ PATTERN_USERS_LIST: newList });
                setDisplayModal(false);
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };
    const handleSearchData = (event) => {
        setSearchString(event);
        let temp_arr = dataset.filter((item) =>
            item.FULL_NAME.toLowerCase().includes(event.toLowerCase())
        );
        setFilteredData(temp_arr);
    };
    useEffect(() => {
        setFilteredData(dataset);

    }, [dataset]);
    
    return (
        <>
        {displayModal == true ?
            <div className={[MainStyle.modal].join(" ")}>
              <div className={[MainStyle.modal_dialog].join(" ")}>
                <div className={[MainStyle.modal_content, MainStyle.rounded_3, MainStyle.shadow_sm, MainStyle.border, MainStyle.bg_card, MainStyle.mx_3].join(" ")}>
                  <div className={MainStyle.m_3}>
                    <div className={MainStyle.modal_header}>
                      <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_4, MainStyle.fw_semibold].join(" ")}>
                            {GetLabel(appLang, 219)}
                      </span>
                    </div>
                    <div className={MainStyle.modal_body}>
                        <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_12}>
                                    <InputGeneral 
                                        value={searchString}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => handleSearchData(event.target.value)}
                                        placeholder={GetLabel(appLang, 33)}
                                        maxLength={500}
                                    />
                                </div>
                        </div>



                        <div className={[MainStyle.overflow_y_scroll].join(" ")} style={{height: '20rem'}}>

                        
                        {  filteredData !== dataset ?
                            
                            filteredData.length == 0 ?
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg_12}>
                                        <p className={[  MainStyle.fs_7,
                                                         MainStyle.text_body_faded,
                                                         MainStyle.fw_semibold,
                                                         MainStyle.mt_3,
                                                         MainStyle.text_center
                                                        ].join(" ")}
                                        >
                                            {GetLabel(appLang, 220)}   
                                        </p>
                                    </div>
                                </div>
                            :
                            filteredData.map((data) => {
                                return (
                                    <div key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom, MainStyle.clickable].join(" ")}
                                         onClick={() => handleSelect(data.USER_ID, 
                                                                     data.FULL_NAME, 
                                                                     data.COMPANY_POSITION_DESC,
                                                                     data.SECTOR_DESC,
                                                                     data.FILE_DATA)}
                                         alt={data.FULL_NAME}
                                    >
                                            <div className={MainStyle.col_12}>
                                                <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                    <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                         className={[MainStyle.border,
                                                                     MainStyle.shadow, 
                                                                     MainStyle.rounded_circle,
                                                                     MainStyle.my_2].join(" ")}
                                                    >
                                                        {
                                                            data.FILE_DATA != null ?
                                                                <img  src={getImgSrc(data.FILE_DATA)} 
                                                                      style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                                />
                                                            :
                                                                <Avatar/>
                                                        }
                                                    </div>
                                                    <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3, MainStyle.mx_3].join(" ")}>
                                                        {data.FULL_NAME} ({data.COMPANY_POSITION_DESC}) {GetLabel(appLang, 44)} {data.SECTOR_DESC}
                                                    </p>
                                                </div>
                                            </div>
                                    </div>
                                );
                            })
                        :
                            dataset.length > 0 ?                             
                            dataset.map((data) => {
                                return (
                                    <div key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom, MainStyle.clickable].join(" ")}
                                        onClick={() => handleSelect(data.USER_ID, 
                                                                    data.FULL_NAME, 
                                                                    data.COMPANY_POSITION_DESC,
                                                                    data.SECTOR_DESC,
                                                                    data.FILE_DATA)}
                                         alt={data.FULL_NAME}
                                    >
                                            <div className={MainStyle.col_12}>
                                                <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                    <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                         className={[MainStyle.border,
                                                                     MainStyle.shadow, 
                                                                     MainStyle.rounded_circle,
                                                                     MainStyle.my_2].join(" ")}
                                                    >
                                                        {
                                                            data.FILE_DATA != null ?
                                                                <img  src={getImgSrc(data.FILE_DATA)} 
                                                                      style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                                />
                                                            :
                                                                <Avatar/>
                                                        }
                                                    </div>
                                                    <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3, MainStyle.text_start, MainStyle.mx_3].join(" ")}>
                                                        {data.FULL_NAME} ({data.COMPANY_POSITION_DESC}) {GetLabel(appLang, 44)} {data.SECTOR_DESC}
                                                    </p>
                                                </div>
                                            </div>
                                    </div>
                                );
                            })
                            :
                            null
                        }
                        </div>
                    </div>
                    <div className={MainStyle.my_3}></div>
                    <div className={MainStyle.row}>
                      <div className={MainStyle.col_lg_7}></div>
                      <div className={MainStyle.col_lg_2}></div>
                      <div className={MainStyle.col_lg_1}></div>
                      <div className={MainStyle.col_lg_2}>
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                              style={{width: '100%'}}
                              className={[MainStyle.btn_blue, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow_sm, MainStyle.fs_6, MainStyle.text_white, MainStyle.py_3, MainStyle.px_3].join(" ")}
                              onClick={() => setDisplayModal(false)}
                            >
                              {GetLabel(appLang, 53)}
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        :
        null
        }
        </>
    );

};

const UserHasAccess = ({itemId, objectSet, dataset}) => {
    const { showLoader,  hideLoader     }  = useLoader();         // Control over the loader
    const { showInfoMessage             }  = useInfoMsgModal();   // Modal message control     
    const { showToastMessage            }  = useToastMessage();   // Toast message display

    const handleDelete = async (user_id) => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await removePatternUser(itemId, user_id);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 221)});
                
                //  Handle the object state
                const newList = dataset.filter(user => user.USER_ID !== user_id);
                objectSet({ PATTERN_USERS_LIST: newList });
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    useEffect(() => {
    }, [ dataset ]);
    
    return (
        <>
            <div className={dataset.length > 0 ? MainStyle.overflow_y_scroll : null}
                 style={dataset.length > 0 ? {height: '20rem'}: null}
            >
                {
                    dataset.map((data) => {
                        return (
                            <div  key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom].join(" ")}>
                                    <div className={MainStyle.col_1}/>
                                    <div className={MainStyle.col_10}>
                                        <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                            <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                className={[MainStyle.border,
                                                            MainStyle.shadow, 
                                                            MainStyle.rounded_circle,
                                                            MainStyle.my_2].join(" ")}
                                            >
                                                {   
                                                    data.FILE_DATA != null ?
                                                        <img 
                                                            src={getImgSrc(data.FILE_DATA)} 
                                                            style={{width: '100%', height: '100%', objectFit:'cover', objectPosition: 'center'}}
                                                        />
                                                    :
                                                        <Avatar/>
                                                }
                                            </div>
                                            <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3].join(" ")}>
                                            {data.FULL_NAME} ({data.COMPANY_POSITION_DESC}) {GetLabel(appLang, 44)} {data.SECTOR_DESC}
                                            </p>
                                            <div 
                                                className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1].join(" ")}
                                                onClick={() => {handleDelete(data.USER_ID)}}                                                 
                                            >
                                                <svg 
                                                    xmlns="http://www.w3.org/2000/svg" 
                                                    viewBox="0 0 448 512"
                                                    className={[MainStyle.small_ico_generic].join(" ")}
                                                >
                                                    <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={MainStyle.col_1}/>
                            </div>
                        );
                    })
                }                        
            </div>
        </>
    );

};

const PatternPermissonPanel = ({ setProps, data }) => {
    const { showLoader,       hideLoader              }  = useLoader();                        // Control over the loader
    const { showInfoMessage                           }  = useInfoMsgModal();                  // Modal message control 
    const { showActionMessage                         }  = useActionModal();                   // Modal message + action control     
    const { showToastMessage                          }  = useToastMessage();                  // Toast message display
    const [ patternUserObj,   setPatternUserObj       ]  = useState(blank_pattern_users_obj);  // Pattern object
    const [ displayModal,     setDisplayModal         ]  = useState(false);

    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_pattern_obj });
    };
    
    const handleChange = (updatedValues) => {
        const mergedValues = {
            ...patternUserObj,
            ...updatedValues
        };
        setPatternUserObj(mergedValues);
    };

    useEffect(() => {
        const fetchData = async (pattern_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getPatternUsers(pattern_id);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            setPatternUserObj(fetchedData);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }                        
            } 
            catch (error) {
                setPatternUserObj(blank_pattern_users_obj);
            }
        };
        if (data?.PATTERN_ID && data.PATTERN_ID !== 0) {
            fetchData(data.PATTERN_ID);
        }
    }, [data]);

    return(
        <>
            <SelectDataPopup 
                            displayModal={displayModal}                 
                            setDisplayModal={setDisplayModal} 
                            objectSet={handleChange} 
                            mainDataset={patternUserObj}
                            dataset={patternUserObj.USERS_LIST}
            />
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={handleExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>

                    <div className={MainStyle.mt_3}/>
                    
                    {/*             Main Label              */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <span className={[MainStyle.fs_5,MainStyle.text_body,MainStyle.fw_semibold].join(" ")}>
                                {GetLabel(appLang, 222)}: {patternUserObj.PATTERN_DESC}
                            </span>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>                    
                    
                    <DefaultPadding/>
                    {/*     Label item list + btn add more  */}
                    <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_8}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                    MainStyle.text_body,
                                                    MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 180)}:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_2}>
                            <div className={MainStyle.mx_3}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_blue, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_7,
                                                MainStyle.text_white,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={() => {setDisplayModal(true);}}
                                >
                                    {GetLabel(appLang, 223)}
                                </button>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    <DefaultPadding/>                    
                    {/*     List of users that has access  */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <UserHasAccess objectSet={handleChange} itemId={patternUserObj.PATTERN_ID} dataset={patternUserObj.PATTERN_USERS_LIST}/>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>


                    <DefaultPadding/>
                </div>
                
                <div className={MainStyle.my_5}/>

            </div>
        </>
    );

};

const PatternTableGrid = ({setProps}) => {
    const [ isLoading,  setIsLoading]            = useState(false);   // Loading fetch control
    const { showLoader, hideLoader }             = useLoader();       // Control over the  
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def
    const gridRef                                = useRef();
    const { showInfoMessage }                    = useInfoMsgModal(); // Modal message control 

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const EditItem = (props) => {
        const handleData = () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_pattern_obj));
            obj_copy.PATTERN_ID = props.data.PATTERN_ID;
            setProps({ setScreen: 2, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const EditItemPermission = (props) => {
        const handleData = () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_pattern_obj));
            obj_copy.PATTERN_ID = props.data.PATTERN_ID;
            setProps({ setScreen: 3, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 640 640" 
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"/>
                    </svg>
                </div>
            </>             
        );
    };

    const defaultCol = [
        DavidCopperfield(10,89,4) && {
          headerName: GetLabel(appLang, 115),
          field: 'editar',
          cellRenderer: EditItem,
          cellClass: [MainStyle.table_text_center].join(" "), 
          headerClass: MainStyle.table_header_center,
          flex: 0,
        },
        DavidCopperfield(10,89,4) && {
            headerName: GetLabel(appLang, 224),
            field: 'permissão',
            cellRenderer: EditItemPermission,
            cellClass: [MainStyle.table_text_center].join(" "), 
            headerClass: MainStyle.table_header_center,
            flex: 0,
        },
        { headerName: GetLabel(appLang, 34),   field: "PATTERN_ID"        ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" ")}    ,
        { headerName: GetLabel(appLang, 225),  field: "PATTERN_DESC"      ,filter: true , flex: 1, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
        { headerName: GetLabel(appLang, 117),  field: "CREATED"           ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
        { headerName: GetLabel(appLang, 118),  field: "UPDATED"           ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!isLoading) {
                setIsLoading(true);
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let data = await getPatternList();
                if (data) {
                    if (data?.status?.statusCode == 0) {
                        data = data.response.content;
                        setcolumnDefs(defaultCol);
                        let arr = [];
                        for(var j = 0; j < data.length; j++) {
                            arr.push(data[j]);
                        }
                        setRowData(arr);
                        hideLoader();
                        setIsLoading(false);
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                    }
                }
            }
        };
        fetchData();
    },[]);

    return (
        <>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    </>);
};

export const PatternPage = () => {
    const [ screenType,         setScreenType       ]   = useState(1);
    const [ defaultData,        setDefaultData      ]   = useState({});
    const [ questionList,       setQuestionList     ]   = useState(null);
    const { showInfoMessage                         }   = useInfoMsgModal();
    const navigate                                      = useNavigate();    

    useEffect(() => {
        if (!Heimdall([10])) {
            navigate('/home');
            return;
        }
        else {
            SetLastFeature(10);
        }        
        const fetchData = async () => {
            let data = await getQuestionList();
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    setQuestionList(data);
                }
                else {
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }
        };
        fetchData();
    },[]);

    const BtnNew = () => {
        handleChange({ setScreen: 2,data: blank_pattern_obj });
    };

    const handleChange = ({ setScreen, data }) => {
        setDefaultData({ ...data });
        setScreenType(setScreen);
    };

    useEffect(() => {
    }, [screenType, defaultData]);

    return (
        <>
        {
        screenType == 1? 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 226)}
                </p>
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_10}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(10,89,0) && (
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_blue, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_5].join(" ")}
                                onClick={BtnNew}
                            >
                                {GetLabel(appLang, 120)}
                            </button>
                        </div>
                    )}
                </div>
            </div>            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_12}>
                    <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                        <PatternTableGrid setProps={handleChange}/>
                    </div>
                </div>
            </div>
            <div className={MainStyle.pb_3}></div>
        </>
        : screenType == 2?
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 227)}
                </p>
            </div>
            <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                <PatternEditPanel setProps={handleChange} data={defaultData} questionList={questionList} />
            </div>
        </>
        : screenType == 3 ?
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 228)}
                </p>
            </div>
            <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                <PatternPermissonPanel setProps={handleChange} data={defaultData} />
            </div>
        </>
        : null
        }
        </>
    );
};